<app-breadcrumb></app-breadcrumb>
<div class="container">
    <div class="row">
        <div class="col-sm-12">
            <app-system-wide-message></app-system-wide-message>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-6">
            <div>
                <div class="mx-auto" >
                    <span class="badge">Details</span>
                    <div class="route-label" *ngFor="let trip of trips">
                        <div class="route-name">
                            <h2> {{ trip.id }} </h2>
                        </div>
                        <div class="route-details">
                            <strong><div class="">to {{ trip.destination }}</div></strong>
                        </div>
                    </div>
                    <div class="row d-flex p-2 text-center">
                        <nav>
                            <div class="nav nav-tabs" id="nav-tab" role="tablist">
                                <a class="nav-item nav-link active" id="nav-alert-tab" data-toggle="tab" href="#nav-alert" role="tab" aria-controls="nav-alert" aria-selected="true">
                                    <span class="badge">
                                        Details
                                    </span>
                                </a>
                                <a class="nav-item nav-link" id="nav-advisory-tab" data-toggle="tab" href="#nav-advisory" role="tab" aria-controls="nav-advisory" aria-selected="false">
                                    <span class="badge">
                                        Schedule
                                    </span>
                                </a>
                            </div>
                        </nav>
                    </div>
                    <div class="tab-content" id="nav-tabContent">
                        <div class="tab-pane fade show active" id="nav-alert" role="tabpanel" aria-labelledby="nav-alert-tab" *ngFor="let trip of trips">
                            <br/>
                            <div class="alert alert-success text-center" role="alert" [ngClass]="{'alert-warning': trip.delay > 0 }">
                                {{ trip.status }}
                            </div>
                            <p> Line: <strong>{{ trip.route }}</strong></p>
                            <p> Destination: <strong> {{ trip.destination }} </strong></p>
                            <p> Current Stop: <strong> {{ trip.currentstop }} </strong></p>
                            <p> Next Stop: <strong> {{ trip.nextstop }} </strong></p>
                            <p> Cars: <strong>{{ trip.cars }} -</strong> {{ trip.vehicle }}</p>
                            <p> Type: <strong> {{ trip.type }} </strong></p>
                        </div>
                        <div class="tab-pane fade" id="nav-advisory" role="tabpanel" aria-labelledby="nav-advisory-tab" >
                            <br/>
                            <table class="table table-bordered">
                                <thead>
                                <tr>
                                    <th scope="col">Stop</th>
                                    <th scope="col">Scheduled</th>
                                    <th scope="col" class="d-none d-sm-table-cell">Estimated</th>
                                    <th scope="col">Actual</th>
                                </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let schedule of schedules">
                                        <td scope="row"> {{ schedule.stop }} </td>
                                        <td> {{ schedule.scheduled }} </td>
                                        <td class="d-none d-sm-table-cell"> {{ schedule.estimated }} </td>
                                        <td> {{ schedule.actual }} </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-6">
                <div>
                    <span class="badge">Map</span>

                    <div class="card mt-2 mb-3">
                        <div>
                            <app-embedded-map-detail></app-embedded-map-detail>
                        </div>
                    </div>
                </div>
        </div>
      </div>
</div>
<app-main-footer></app-main-footer>